import { create } from 'zustand'

const useHeaderStore = create((set) => ({
    headerTitle: true,
    setHeaderTitle: (title) => set({ headerTitle: title }),
}));

export default useHeaderStore;

